import { useDispatch } from 'react-redux';
import _ from 'lodash';
import { SettingValues } from 'common/services/settings.service';
import {
  jobPollingListener,
  JOB_NAMES,
  JOB_STATES
} from 'common/services/jobs-suites.service';
import { getContributors, getTeams } from 'state/callers';
import useToast from 'components/hooks/useToast';
import useSettingsService from 'components/hooks/useSettingsService';

export const SYNC_TEAMS_SETTING_STATUSES = {
  PENDING: 'pending',
  SUCCEED: 'succeed',
  FAILED: 'failed'
};

const useGitSelectedSyncTeamsSetting = () => {
  const toast = useToast();
  const dispatch = useDispatch();
  const { updateSetting, getSettingOrDefinitionValue } = useSettingsService();
  const settingValue = getSettingOrDefinitionValue({
    name: SettingValues.GIT_SELECTED_SYNC_TEAMS
  });

  const getSelectedProviderIds = (sensorAuthId, orgName) => {
    const settingKey = `${orgName}_${sensorAuthId}`;
    return _.get(settingValue, `${settingKey}.selected_nodes`, []);
  };

  const generateSettingKey = (sensorAuthId, orgName) =>
    `${orgName}_${sensorAuthId}`;

  const onSave = async (sensorAuthId, orgName, selectedTeams) => {
    const settingKey = generateSettingKey(sensorAuthId, orgName);

    const settingPayload = {
      org_login: orgName,
      sensor_authorization_id: sensorAuthId,
      selected_nodes: selectedTeams.map(team => _.get(team, 'id')),
      status: SYNC_TEAMS_SETTING_STATUSES.PENDING
    };
    const newSettingValue = {
      ...settingValue,
      [settingKey]: settingPayload
    };
    await updateSetting(SettingValues.GIT_SELECTED_SYNC_TEAMS, newSettingValue);

    toast({
      message: `Team settings saved successfully, it may take a little while to update.`,
      variant: 'success'
    });

    /* istanbul ignore next */
    jobPollingListener({
      jobName: JOB_NAMES.SYNC_GIT_TEAMS,
      onStateChange: state => {
        /* istanbul ignore next */
        if (state === JOB_STATES.completed) {
          getTeams()(dispatch);
          getContributors()(dispatch);
          toast({
            message: `Teams synced successfully! You can now view your synced teams`,
            variant: 'success'
          });
        }
      }
    });
  };

  return {
    value: settingValue,
    getSelectedProviderIds,
    onSave
  };
};

export default useGitSelectedSyncTeamsSetting;
